import { render, staticRenderFns } from "./tailorRequests.vue?vue&type=template&id=625019ac&scoped=true&"
import script from "./tailorRequests.vue?vue&type=script&lang=js&"
export * from "./tailorRequests.vue?vue&type=script&lang=js&"
import style0 from "./tailorRequests.vue?vue&type=style&index=0&id=625019ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625019ac",
  null
  
)

export default component.exports